import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { ar } from "date-fns/locale/ar";
import "react-datepicker/dist/react-datepicker.css";
import "./CustomDatePicker.css"; // ملف CSS المخصص

// ✅ تسجيل اللغة العربية
registerLocale("ar", ar);

const CustomDatePicker = ({ 
  value, 
  onChange, 
  label, 
  placeholder = "اختر التاريخ",
  minDate = null,
  maxDate = null 
}) => {
  return (
    <div className="custom-datepicker-wrapper">
      {label && (
        <label className="datepicker-label">
          {label}
        </label>
      )}
      <DatePicker
        selected={value ? new Date(value) : null}
        onChange={(date) => {
          if (date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            onChange(formattedDate);
          } else {
            onChange("");
          }
        }}
        locale="ar"
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder}
        className="custom-datepicker-input"
        calendarClassName="custom-datepicker-calendar"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        minDate={minDate}
        maxDate={maxDate}
        isClearable
        autoComplete="off"
      />
    </div>
  );
};

export default CustomDatePicker;